import React from 'react';
import { Label, Icon, SemanticCOLORS } from 'semantic-ui-react';
import clsx from 'clsx';

export interface POSRemovePillProps {
  secondary?: boolean;
  children: React.ReactNode;
  disabled?: boolean;
  onClick?: () => void;
  color?: SemanticCOLORS;
}

export const POSRemovePill = ({
  color = 'black',
  disabled = false,
  onClick,
  children,
  secondary,
}: POSRemovePillProps) => {
  const handleChange = () => {
    onClick && !disabled && onClick();
  };

  return (
    <Label
      as="a"
      size={secondary ? 'small' : 'large'}
      basic
      color={color}
      className={clsx('pos-pill', { disabled: disabled })}
      onClick={handleChange}
    >
      {children}
      <Icon name="delete" />
    </Label>
  );
};
